module.exports = __webpack_public_path__ + "static/media/Simple_Item_Frame@3x.8989569e.png";